import React, { useEffect, useState } from "react";
import Button from "../../../components/Button/Button";
import { MdAddBox } from "react-icons/md";
import CategoryTable from "../../../components/Table/CategoryTable";
import AddCategory from "./AddCategory/AddCategory";
import { CategoryService } from "./CategoryService";
import Loader from "../../../components/Loader/Loader";
import EditCategory from "./EditCategory/EditCategory";
import { toast } from "react-toastify";

const Categories = () => {
  const [isShowAddCategory, setIsShowAddCategory] = useState<boolean>(false);
  const [categories, setCategories] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [isShowEditCategory, setIsShowEditCategory] = useState<boolean>(false);
  const [selectedCategory, setSelectedCategory] = useState<any>(null);

  const columns = ["Image", "Title", "Description", "No of Products", ""];
  const columnsKeys = ["image_url", "title", "description"];

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = () => {
    setLoading(true);
    CategoryService.getCategories().then((res) => {
      setCategories(res.data);
      setLoading(false);
    });
  };

  const onDelete = async (item: any) => {
    setLoading(true);
    if (item.products.length === 0) {
      const res: any = await CategoryService.deleteCategory(item.id);
      console.log(res);
      if (res.status === 200) {
        toast.success("Category deleted successfully!", {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        fetchCategories();
      } else {
        setLoading(false);
      }
    } else {
      setLoading(false);
      toast.error("Can't delete category with products!", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const onEdit = async (item: any) => {
    console.log(item);
    setSelectedCategory(item);
    setIsShowEditCategory(true);
  };

  return (
    <div className="bg-white h-full w-full rounded-lg p-2">
      {loading && (
        <div className="fixed w-screen h-screen bg-black bg-opacity-10 top-0 right-0 z-30 flex items-center justify-center">
          <Loader />
        </div>
      )}
      {isShowAddCategory && (
        <AddCategory
          onClose={() => {
            setIsShowAddCategory(false);
            fetchCategories();
          }}
        />
      )}

      {isShowEditCategory && (
        <EditCategory
          onClose={() => {
            setIsShowEditCategory(false);
            fetchCategories();
          }}
          data={selectedCategory}
        />
      )}

      <div className="flex w-full justify-between items-center">
        <h3 className="text-xl font-semibold">Categories</h3>

        <Button
          className="!bg-blue-500 text-white flex gap-2 items-center !mt-0"
          disabled={false}
          onClick={() => setIsShowAddCategory(!isShowAddCategory)}
        >
          <MdAddBox />
          Add Category
        </Button>
      </div>
      {categories.length > 0 && (
        <CategoryTable
          columns={columns}
          data={categories}
          columnsKeys={columnsKeys}
          onEdit={(item: any) => onEdit(item)}
          onDelete={(item: any) => onDelete(item)}
        />
      )}
    </div>
  );
};

export default Categories;
